/* @jsxImportSource react */

import * as React from 'react';

export interface PriceUnitPriceProps extends React.HTMLAttributes<
  Omit<HTMLSpanElement, 'className'>
> {}

const PriceUnitPrice = ({ children, 'aria-label': srLabel, ...props }: PriceUnitPriceProps) => (
  <>
    {srLabel && <span className="sr-only">{srLabel}</span>}
    <span
      className="text-size-body-xs text-color-text-darktransparent inline-flex grow-0 items-center justify-start [grid-area:d] empty:hidden"
      {...props}
    >
      {children}
    </span>
  </>
);

PriceUnitPrice.displayName = 'PriceUnitPrice';

export { PriceUnitPrice };
